import {StyleSheet, PixelRatio} from 'react-native';
import {NAVBAR_HEIGHT, getScreenSize} from "../../../../common/utils";
export default StyleSheet.create({
    searchBoxFix:{
        position: 'absolute',
        top: NAVBAR_HEIGHT,
        width: getScreenSize().width,
        height: getScreenSize().height,
        backgroundColor: 'rgba(0,0,0, .4)',
        zIndex: 100,
        overflow:'hidden'
    },
    searchBoxFixContainer:{
        position: 'absolute',
        width: '100%',
        backgroundColor: '#f7f8fa',
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        paddingBottom: 8,
        top: -262,
    }
});